import React from "react";
import T from "prop-types";

export default function StatusTags({ children }) {
  return <div className="status-tags alert-group pull-right">{children}</div>;
}

StatusTags.propTypes = {
  children: T.oneOfType([T.element, T.arrayOf(T.element)]).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatusTags/StatusTags.jsx